module.exports = __webpack_public_path__ + "img/legende375.9b37766a.jpg";